import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-28e19a84")

_pushScopeId("data-v-28e19a84")
const _hoisted_1 = { class: "icon" }
const _hoisted_2 = { class: "icon" }
const _hoisted_3 = { class: "icon" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    class: ["d-prediction-sumary-view-root", { vertical: !_ctx.isHorizontal }],
    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.clicked())),
    "data-label": _ctx.label,
    "data-color": _ctx.color
  }, [
    _createVNode("div", _hoisted_1, [
      (_ctx.hasBigEye)
        ? (_openBlock(), _createBlock("span", {
            key: 0,
            class: ["icon-circlestroke", _ctx.bigeyeColor]
          }, null, 2))
        : _createCommentVNode("", true)
    ]),
    _createVNode("div", _hoisted_2, [
      (_ctx.hasSmall)
        ? (_openBlock(), _createBlock("span", {
            key: 0,
            class: ["icon-circlefill", _ctx.smallColor]
          }, null, 2))
        : _createCommentVNode("", true)
    ]),
    _createVNode("div", _hoisted_3, [
      (_ctx.hasCockRoach)
        ? (_openBlock(), _createBlock("span", {
            key: 0,
            class: ["icon-vertical", _ctx.cockRoachColor]
          }, null, 2))
        : _createCommentVNode("", true)
    ])
  ], 10, ["data-label", "data-color"]))
})